module.exports = __webpack_public_path__ + "list-spaces.ee06caed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/AdminRegistration/list-spaces.png
// module id = 3127
// module chunks = 0